<template>
  <div class="case-sidepanel px-4">
    <b-row class="d-flex align-items-center mb-2">
      <b-col class="d-flex align-items-center">
        <!-- TODO: Pendiente de que el título del estudio sea dinámico -->
        <span class="ap-title ap-title__main"><i
          class="far fa-chart-network mr-2"
          aria-hidden="true"
        />{{ casNumber }}</span>
      </b-col>
      <b-col
        cols="auto"
        class="d-flex justify-content-end"
      >
        <div>
          <b-button
            v-shortkey="['shift', 'esc']"
            class="btn__icon btn__icon--primary p-0"
            @shortkey="closeCaseSidepanel"
            @click="closeCaseSidepanel"
          >
            <i
              class="far fa-times"
              aria-hidden="true"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="assaysData">
      <b-col>
        <b-tabs
          class="vt-tabs sr-detail-tabs"
          content-class="mt-3"
        >
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
          >
            <template slot="title">
              <div class="d-flex align-items-center">
                <i
                  v-tooltip="tab.title"
                  :class="tab.icon"
                  aria-hidden="true"
                />
                <vtBubble
                  v-if="assaysData[tab.state].length"
                  :number="assaysData[tab.state].length"
                  :info="true"
                  class="ml-1"
                />
              </div>
            </template>
            <div class="px-3 scroll-area">
              <b-row class="mb-2">
                <b-col>
                  <span class="ap-title ap-title__section">{{ assaysData[tab.state].length }} {{ tab.title }}</span>
                </b-col>
              </b-row>
              <b-row
                v-for="(assay, indexAssay) in assaysData[tab.state]"
                :key="indexAssay"
                class="tech-row bottom-bordered py-2"
              >
                <b-col
                  lg="4"
                  md="5"
                  sm="6"
                  class="d-flex align-items-center"
                >
                  <div
                    v-tooltip="assay.assayStatus.name"
                    class="mr-2 state-circle"
                    :class="{'state-pending': assay.assayStatus.code === 'PENDING',
                             'state-process-1': assay.assayStatus.code === 'IN_PROCESS',
                             'state-canceled': assay.assayStatus.code === 'CANCELED',
                             'state-success': assay.assayStatus.code === 'FINISHED'
                    }"
                  />
                  <span class="dark">{{ assay.label }}</span>
                  <priority-dot
                    class="ml-3"
                    :priority="assay.priority"
                    :size="10"
                  />
                </b-col>
                <b-col><span class="dark">{{ assay.assay ? `${assay.assay.name} - ${assay.assay.assaygroup.name}` : '' }}</span></b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import subportionService from '@/modules/diagnosisModule/services/subportionService'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'

export default {
    name: 'CaseSidepanel',
    components: {
        VtBubble,
        PriorityDot
    },
    data() {
        return {
            casId: null,
            casNumber: null,
            labId: null,
            mockupValue: 2,
            assaysData: null,
            tabs: [
                {
                    icon: 'fas fa-arrow-circle-right',
                    title: this.$t('diagnosis.grid.caseGrid.requestedTechniques'),
                    state: 'requested'
                },
                {
                    icon: 'fal fa-cut',
                    title: this.$t('diagnosis.grid.caseGrid.pendingCutTechniques'),
                    state: 'pendingCut'
                },
                {
                    icon: 'fal fa-paint-brush-alt',
                    title: this.$t('diagnosis.grid.caseGrid.pendingDyeingTechniques'),
                    state: 'pendingStain'
                },
                {
                    icon: 'fal fa-envelope',
                    title: this.$t('diagnosis.grid.caseGrid.pendingDeliveryTechniques'),
                    state: 'pendingDeliveryToPathologistOrScan'
                },
                {
                    icon: 'fal fa-times-circle',
                    title: this.$t('diagnosis.grid.caseGrid.canceledTechniques'),
                    state: 'canceled'
                }
            ]
        }
    },
    methods: {
        closeCaseSidepanel() {
            this.$emit('closeCaseSidepanel', false)
        },
        async loadAssaysData(casId, casNumber, labId) {
            this.assaysData = null
            this.labId = labId
            this.casId = casId
            this.casNumber = casNumber
            this.updateLoading(true)
            const [err, response] = await this.toCall(subportionService.getAssaySummaryForCase(this.labId, this.casId))
            if (err) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            this.assaysData = response
            this.updateLoading(false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .case-sidepanel .title {
        font-size: font-size(big);
        color: vt-color(primary);
    }

    .case-sidepanel .tech-row {
        border-bottom: 1px solid rgb(209, 209, 209);
        font-size: font-size(small);
    }

    .case-sidepanel .scroll-area{
        height: calc(100vh - 205px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    @media (max-width: 1300px) {
        .case-sidepanel .title {
            font-size: font-size(normal);
            color: vt-color(primary);
        }

        .case-sidepanel .scroll-area{
            height: calc(100vh - 180px);
            overflow-y: auto;
            overflow-x: hidden;
        }
    }
</style>

<style lang="scss">
    .case-sidepanel .vt-tabs .nav-tabs .nav-link.active,
    .vt-tabs--small .nav-tabs .nav-link.active {
        border-bottom: 2px solid vt-color(primary);
    }

    .case-sidepanel .vt-tabs .nav-tabs .nav-link,
    .vt-tabs--small .nav-tabs .nav-link {
        border-bottom: 2px solid transparent;
    }

    .case-sidepanel .vt-tabs .nav-tabs .nav-link,
    .vt-tabs--small .nav-tabs .nav-link i {
        font-size: font-size(very-normal);
    }

    .case-sidepanel .showtooltip {
        display: block;
    }

    .case-sidepanel .noshowtooltip {
        display: none;
    }

</style>
